<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

    <div class="w-full p-2 flex-1">

      <!-- Bouton Retour -->
      <div class="mx-auto max-w-2xl m-4 w-full">
        <button (click)="cancel()"
                class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
          Retour
        </button>
      </div>

      <!-- LISTE SCROLLABLE -->
      <div class="overflow-y-auto max-h-[30vh] pr-2">
        <ul class="list-none p-0 my-4">
          <li *ngFor="let item of itemList"
              (click)="toggleItem(item)"
              [ngClass]="[
                'flex items-center justify-between p-2 mb-2 rounded hover:bg-green-200 cursor-pointer transition',
                isSelected(item) ? 'bg-green-100 font-bold' : 'bg-gray-100',
                item.shared_index ? 'opacity-50' : ''
              ]">

            <span *ngIf="item.alreadyPaid && item.remainingQuantity===0"><s>{{ item.name }}</s></span>

            <div *ngIf="item.remainingQuantity > 0" class="flex flex-col text-sm">
              <span class="font-semibold">{{ item.name }}</span>
              <span class="text-xs text-gray-500" *ngIf="item.quantity && item.quantity > 1">x{{ item.quantity }}</span>
            </div>

            <div class="text-right">
              <span *ngIf="item.alreadyPaid && item.remainingQuantity >= 1" class="font-bold">
                {{ item.unit_ttc * item.remainingQuantity | number:data.currencyFormat.decimalsString }}
                {{ data.currencyFormat.currencySymbol }}
              </span>
              <span *ngIf="!item.alreadyPaid" class="font-bold">
                {{ computeTotalTtc(item) | number:data.currencyFormat.decimalsString }}
                {{ data.currencyFormat.currencySymbol }}
              </span>

              <p *ngIf="item.free === 1" class="text-sm font-semibold">
                {{ getFreeLabel(item) }}
              </p>
              <p *ngIf="item.alreadyPaid" class="text-sm text-green-500">
                {{ getPaidLabel(item) }}
              </p>
            </div>

            <ng-container *ngIf="item.shared_index">
              <button (click)="cancelDivision(item)" [disabled]="isAnyPartPaid(item)"
                      [title]="isAnyPartPaid(item) ? 'Impossible d\'annuler une fois qu\'une partie est payée' : 'Annuler la division'">
                <mat-icon>cancel</mat-icon>
              </button>
            </ng-container>
          </li>
        </ul>
      </div>

      <!-- CONTROLES NOMBRE DE PARTS -->
      <div class="w-full mt-3">
        <label class="flex justify-center block text-sm font-bold mb-1">Nombre de parts</label>
        <div class="flex items-center gap-2 mt-3">
          <button mat-mini-fab color="primary" (click)="decreaseParts()" [disabled]="sharedParts <= 2">
            <mat-icon>remove</mat-icon>
          </button>

          <input type="number" [value]="sharedParts"
                 class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 text-center"
                 readonly>

          <button mat-mini-fab color="primary" (click)="increaseParts()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>

      <!-- Bouton Valider -->
      <div class="mx-auto max-w-2xl m-4 w-full">
        <button [disabled]="selectedItems.length === 0"
                (click)="confirm()"
                class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
          Valider
        </button>
      </div>
    </div>
 </app-dialog-wrapper>